import { useEffect } from "react";
import { useStore } from "zustand";
import { WatchCloseRoutesLogsUseCase } from "@useCases/index";
import { FirebaseCloseRoutesLogRepository } from "@data/repositories/index";
import userStore from "@data/stores/user";
import closeRoutesLogsStore from "@data/stores/closeRoutesLog";

export default function useCloseRoutesLogs() {
  const { closeRoutesLogs } = useStore(closeRoutesLogsStore);

  const getCloseRoutesLogs = async () => {
    const useCase = new WatchCloseRoutesLogsUseCase(
      userStore.getState(),
      new FirebaseCloseRoutesLogRepository(closeRoutesLogsStore.getState())
    );

    useCase.execute();
  };

  useEffect(() => {
    if (closeRoutesLogs.length === 0) {
      getCloseRoutesLogs();
    }
  }, []);

  return {
    closeRoutesLogs,
  };
}
